import { createLazyComponent } from '@muse-web/router'

export const AsyncConverterPromoDialogContainer = createLazyComponent(
    () =>
        import(/* webpackChunkName: 'dialog-converter-promo' */ './ConverterPromoDialogContainer'),
    'ConverterPromoDialogContainer',
)
